/* Contact page - FAQ toggle */

$(document).ready(function() {
    if( $(".content-faq .js-faq").hasClass('active') ){
        $(".content-faq .js-faq.active").closest('.toggle').find('.content').show();
    }

    $(".content-faq .js-faq").click(function(){
        var faqArrow = $(this).find('img');
        faqArrow.toggle();
        if( $(this).hasClass('active') ){
            $(this).removeClass("active").closest('.content-faq').find('.content').slideUp(200);
        }
        else{   $(this).addClass("active").closest('.content-faq').find('.content').slideDown(200);
        }
    });

});
